import '../App.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Header() {
    var linkGithub = 'https://github.com/ericbrlnk';
    var email = 'hilbert.mol@vp.pl';
    return (
        <div class='header'>
            <h1 class='mt-5'>About</h1>
            <a href = { linkGithub } target = '_blank' rel='noopener noreferrer'>
                <i class='about-icon bi bi-github h1 m-3'></i>
            </a>
            <a href = { `mailto: ${ email }` } target = '_blank' rel='noopener noreferrer'>
                <i class='about-icon bi bi-envelope-at-fill h1 m-3'></i>
            </a>
        </div>
    )
};

export default Header;